import styled from 'styled-components';

import {PriceLabel} from '~/shared/components/PriceLabels';
import {getLocalizationService} from '~/shared/services/localisationService';
import {UserReportPayment} from '~/shared/store/models/User/UserReport';
import {FlexCenterVertically} from '~/shared/theme/FlexLayout';
import {flipOnLTR} from '~/shared/theme/utils';

import {Cell} from './common';

export const ChildTableRow = styled(FlexCenterVertically)<{isOpen?: boolean}>`
  height: 48px;
  color: ${({theme}) => theme.colors.contentDefault};
  justify-content: space-between;
  width: 100%;
  background: ${({theme}) => theme.colors.lightBackground};
  ${({isOpen, theme}) => isOpen && `border-bottom: 1px solid ${theme.colors.gray500}`};
  ${flipOnLTR`
    padding-left: 8px;
    padding-right: 0;
  `}
`;

const InnerChildTable = styled(ChildTableRow)`
  min-height: 48px;
  padding: 16px 0;
  align-items: flex-start;
  height: auto;
  font-weight: 400;
  ${flipOnLTR`
    padding-right: 34px;
  `}
`;

const PaymentsCell = styled(Cell)`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  flex: 1;
  align-items: flex-start;
`;

const PaymentRow = styled(FlexCenterVertically)`
  justify-content: space-between;
  width: calc(100% - 34px);
  height: 26px;
`;

const ChildPayments = ({payments}: {payments: UserReportPayment[]}) => {
  const {t} = getLocalizationService();

  if (!payments?.length) {
    return null;
  }

  return (
    <InnerChildTable>
      <Cell width={120}>{t('payment')}</Cell>
      <PaymentsCell>
        {payments.map(p => (
          <PaymentRow key={p.paymentId}>
            <Cell width={300}>
              {p.cardSuffix} {t(p.paymentMethod.toLowerCase())}
            </Cell>
            <Cell>
              <FlexCenterVertically>
                <PriceLabel price={p.total} />
              </FlexCenterVertically>
            </Cell>
          </PaymentRow>
        ))}
      </PaymentsCell>
    </InnerChildTable>
  );
};

export default ChildPayments;
